<template>
    <div class="router-wrapper"><router-view /></div>
</template>

<script>
  export default {
    name: 'AuthLayout',
  };
</script>